import { createContext } from 'react';
import { AppEntityManager } from '../classes/entities/AppEntityManager';

export const entityManagerContextDefaultValue: EntityManagerContextValue = {
  get entityManager(): AppEntityManager {
    throw new Error(
      'EntityManagerContext not initialized, make sure you are inside the EntityManagerContext'
    );
  }
};

export const EntityManagerContext = createContext<EntityManagerContextValue>(
  entityManagerContextDefaultValue
);

export type EntityManagerContextValue = {
  entityManager: AppEntityManager;
};
